import React, { useEffect } from 'react';
import BaseModal from '../../../components/BaseModal';

const ConfirmModal = ({
  show,
  onClose,
  onConfirm,
  title = 'Onay',
  message = 'Bu işlemi yapmak istediğinize emin misiniz?',
  confirmText = 'Onayla',
  cancelText = 'İptal',
  variant = 'primary', // primary, danger, warning, success
  loading = false,
  size = 'md'
}) => {
  const variantClasses = {
    primary: 'btn-primary',
    danger: 'btn-danger',
    warning: 'btn-warning',
    success: 'btn-success'
  };

  const iconClasses = {
    primary: 'fa-info-circle text-primary',
    danger: 'fa-exclamation-triangle text-danger',
    warning: 'fa-exclamation-circle text-warning',
    success: 'fa-check-circle text-success'
  };

  // Handle Enter key for confirmation
  useEffect(() => {
    if (!show) return;

    const handleEnter = (e) => {
      if (e.key === 'Enter' && !loading) {
        e.preventDefault();
        onConfirm();
      }
    };

    document.addEventListener('keydown', handleEnter);
    return () => document.removeEventListener('keydown', handleEnter);
  }, [show, loading, onConfirm]);

  const renderFooter = () => (
    <div className="d-flex justify-content-end gap-2">
      <button
        type="button"
        className="btn btn-light"
        onClick={onClose}
        disabled={loading}
        autoFocus={false}
      >
        {cancelText}
      </button>
      <button
        type="button"
        className={`btn ${variantClasses[variant] || variantClasses.primary}`}
        onClick={onConfirm}
        disabled={loading}
        autoFocus={!loading}
      >
        {loading ? (
          <>
            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            İşleniyor...
          </>
        ) : (
          confirmText
        )}
      </button>
    </div>
  );

  return (
    <BaseModal
      show={show}
      onHide={onClose}
      title={title}
      size={size}
      footer={renderFooter()}
      closeOnEscape={!loading}
      closeOnBackdrop={!loading}
      ariaLabel={title}
    >
      <div className="d-flex align-items-start">
        <div className="flex-shrink-0 me-3">
          <i className={`fas ${iconClasses[variant] || iconClasses.primary} fa-2x`} style={{ marginTop: '0.25rem' }}></i>
        </div>
        <div className="flex-grow-1">
          <p className="mb-0" style={{ lineHeight: '1.6', fontSize: '0.95rem' }}>{message}</p>
        </div>
      </div>
    </BaseModal>
  );
};

export default ConfirmModal;

